import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";

interface OperatorConflictModalProps {
  open: boolean;
  onCancel: () => void;
  onProceed: () => void;
}

export const OperatorConflictModal = ({
  open,
  onCancel,
  onProceed,
}: OperatorConflictModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "500px",
          width: "90vw",
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: (theme) => theme.palette.warning.main,
          borderBottom: (theme) =>
            `1px solid ${theme.palette.billetYard.borders.medium}`,
          padding: "16px 24px",
        }}
      >
        <Typography
          variant="h5"
          component="div"
          sx={{
            fontWeight: "bold",
            color: "white",
            textAlign: "center",
            fontSize: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: (theme) => theme.spacing(1),
          }}
        >
          <WarningIcon fontSize="large" />
          Operator Conflict
        </Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "24px",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: 1.5,
            color: (theme) => theme.palette.text.primary,
            marginBottom: (theme) => theme.spacing(2),
          }}
        >
          There is another operator logged in the crane. Do you want to log that
          operator off and proceed with this login?
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "24px",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          gap: (theme) => theme.spacing(3),
        }}
      >
        <Button
          variant="contained"
          onClick={onCancel}
          sx={{
            minWidth: "150px",
            minHeight: "56px",
            fontSize: "18px",
            fontWeight: "bold",
            padding: "16px 32px",
            borderRadius: "8px",
            backgroundColor: (theme) =>
              theme.palette.billetYard.backgrounds.light,
            color: (theme) => theme.palette.text.primary,
            border: (theme) =>
              `1px solid ${theme.palette.billetYard.borders.dark}`,
            boxShadow: "0 4px 14px 0 rgba(158, 158, 158, 0.25)",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: (theme) => theme.palette.grey[300],
            },
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={onProceed}
          sx={{
            minWidth: "150px",
            minHeight: "56px",
            fontSize: "18px",
            fontWeight: "bold",
            padding: "16px 32px",
            borderRadius: "8px",
            backgroundColor: (theme) => theme.palette.warning.main,
            color: (theme) => theme.palette.warning.contrastText,
            boxShadow: "0 4px 14px 0 rgba(255, 152, 0, 0.25)",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: (theme) => theme.palette.warning.dark,
            },
            "&:disabled": {
              backgroundColor: (theme) => theme.palette.action.disabled,
              color: (theme) => theme.palette.action.disabled,
            },
          }}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};
